export default {"src":"/_next/static/media/geek-logo-white.d4f2e855.svg","height":652,"width":1326};